import { ArrowLeft, ShieldCheck } from "lucide-react";
import { Link, Outlet } from "react-router";

import { ThemeControl } from "@/theme/theme-control";

// Keep privacy.photos policies lightweight and connected to the local-only
// photo workflow.
//
export default function LegalLayout() {
  return (
    <div className="min-h-dvh">
      <header className="border-b">
        <div className="mx-auto flex h-16 w-[calc(100%-2rem)] max-w-3xl items-center justify-between sm:w-[calc(100%-3rem)]">
          <Link className="flex items-center gap-2 font-semibold" to="/">
            <ShieldCheck className="text-primary size-5" />
            privacy.photos
          </Link>
          <div className="flex items-center gap-2">
            <Link
              className="text-muted-foreground hover:text-foreground flex items-center gap-1.5 text-sm"
              to="/"
            >
              <ArrowLeft className="size-4" /> Tool
            </Link>
            <ThemeControl />
          </div>
        </div>
      </header>
      <main className="mx-auto w-[calc(100%-2rem)] max-w-3xl py-12 sm:w-[calc(100%-3rem)] sm:py-18">
        <Outlet />
      </main>
    </div>
  );
}
